import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { STORAGE_KEYS } from '../constants/storage-keys';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);

  if (auth.isAuthenticated()) {
    return true;
  }

  // Сохраняем intent-URL, чтобы после логина вернуть пользователя туда,
  // куда он шёл — иначе всех кидает на /equipment (default).
  try {
    if (state.url && state.url !== '/') {
      sessionStorage.setItem(STORAGE_KEYS.postLoginRedirect, state.url);
    }
  } catch {}

  auth.login();
  return false;
};
